import { NavigationGuardNext } from 'vue-router';
import { getCampaign } from '../services/api';
import { CreateCampaignStatusEnum1 } from '@ankorstore/api-internal/data-contracts';

export async function campaignCreateGuard(to, _from, next: NavigationGuardNext) {
  to.params.defaultSegment = to.query.defaultSegment;
  to.params.defaultSegmentUuid = to.query.defaultSegmentUuid;
  next();
}

export async function campaignEditGuard(to, _from, next: NavigationGuardNext) {
  try {
    const campaign = await getCampaign(to.params.campaignId);
    if (campaign?.attributes?.status !== CreateCampaignStatusEnum1.Draft) {
      next({ name: 'campaigns' });
    } else {
      to.params.draft = campaign;
      next();
    }
  } catch (err) {
    next({ name: 'campaign-add' });
  }
}
